<template>
  <v-list>
    <v-subheader>
      <v-icon class="mr-2">mdi-email-outline</v-icon>
      Emails
    </v-subheader>
    <v-list-item
      v-for="(email, i) in value"
      :key="`email-${i}`"
      v-on="
        editando
          ? { click: () => $store.commit('contato/editarEmail', email) }
          : {}
      "
    >
      <v-list-item-content>
        <v-list-item-subtitle>
          {{ email.nome }}
          <span v-if="email.principal">&nbsp;(principal)</span>
        </v-list-item-subtitle>
        <v-list-item-title>
          {{ email.email }}
          <v-tooltip bottom v-if="email.descricao !== ''">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small color="info" class="mr-1">
                mdi-information-outline
              </v-icon>
            </template>
            <span>{{ email.descricao }}</span>
          </v-tooltip>
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action v-if="editando">
        <v-btn icon @click.stop="del(i)">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="editando">
      <v-list-item-content>
        <v-btn
          block
          text
          color="primary"
          @click="$store.commit('contato/novoEmail')"
        >
          <v-icon class="mr-2">mdi-email-plus-outline</v-icon>
          NOVO EMAIL
        </v-btn>
      </v-list-item-content>
    </v-list-item>
    <email-form @change="changeEmail($event)" />
  </v-list>
</template>

<script>
import _ from "lodash";
import EmailForm from "./EmailForm";
export default {
  components: { EmailForm },
  props: ["value", "editando"],
  methods: {
    changeEmail(email) {
      let emails = _.clone(this.value);
      if (!email.id) {
        email.id = new Date().getTime();
        emails.push(email);
      } else {
        emails = emails.map((e) => (e.id === email.id ? email : e));
      }

      if (email.principal) {
        emails = emails.map((e) => {
          if (e == email) {
            return e;
          }
          e.principal = false;
          return e;
        });
      }
      this.$emit("input", emails);
    },
    del(idx) {
      let emails = _.clone(this.value);
      emails.splice(idx, 1);
      this.$emit("input", emails);
    },
  },
};
</script>
